<template>
  <div class="Gray_btn">
    <span v-if="url=='back'" @click="goback">{{name}}</span>
    <a v-if="url !== 'back'" :href="url">{{name}}</a>
  </div>
</template>

<script>
export default {
  name: "graybtn",
  components: {},
  props: {
    url: {
      type: String,
      default: "/"
    },
    name: {
      type: String,
      default: "回首頁"
    }
  },
  data() {
    return {};
  },
  methods: {
    goback() {
      const vm = this;
      history.back();
    }
  },
  computed: {},
  created() {},
  mounted() {},
  watch: {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.Gray_btn {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 60px auto;
  text-align: center;
  max-width: 165px;
}
.Gray_btn span,
.Gray_btn a {
  background-color: #a59b92;
  padding: 12px 30px;
  display: block;
  margin: auto;
  cursor: pointer;
  color: #fff;
  width: 100%;
  text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/components/btn/gray.vue